import { CREATE_NOTIFICATION } from './NotificationConstants'

const INITIAL_STATE = {
    counter: 0,
    notif: {},
}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {

        case CREATE_NOTIFICATION:
            const counter = state.counter + 1
            return {
                ...state,
                counter: counter,
                notif: {
                      title: action.title,
			          message: action.message,
			          level: action.level,
			          position:'tc'
                }
            }


        // DEFAULT
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/notification/NotificationReducer.js